// Copyright (C) 2020-2022 Intel Corporation
// Copyright (C) 2024 CVAT.ai Corporation
//
// SPDX-License-Identifier: MIT

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router';

import ReferenceAnnotationPageComponent from 'components/reference-annotation-page/annotation-page';
import {
    getJobAsync,
    saveLogsAsync,
    changeFrameAsync,
    closeJob as closeJobAction,
} from 'actions/reference-annotation-actions';

import { CombinedState, Workspace } from 'reducers';
import { routeJob } from 'utils/workspace-route';

type OwnProps = RouteComponentProps<{
    tid: string;
    jid: string;
}>;

interface StateToProps {
    job: any | null | undefined;
    frameNumber: number;
    fetching: boolean;
    workspace: Workspace;
}

interface DispatchToProps {
    getJob(): void;
    changeFrame(frame: number): void;
    saveLogs(): void;
    closeJob(): void;
}

function mapStateToProps(state: CombinedState, own: OwnProps): StateToProps {
    const { params } = own.match;
    const jobID = +params.jid;
    const {
        annotation: {
            job: { requestedId, instance: job, fetching },
            workspace,
            player: {
                frame: { number: frameNumber },
            },
        },
    } = state;

    return {
        job: routeJob(job, requestedId, jobID, 'reference'),
        fetching,
        workspace,
        frameNumber,
    };
}

function mapDispatchToProps(dispatch: any, own: OwnProps): DispatchToProps {
    const { params } = own.match;
    const referenceID = +params.tid;
    const jobID = +params.jid;
    const searchParams = new URLSearchParams(window.location.search);
    const initialFilters: object[] = [];
    const initialOpenGuide = searchParams.has('openGuide');
    const parsedFrame = +(searchParams.get('frame') || 'NaN');
    const initialFrame = Number.isInteger(parsedFrame) && parsedFrame >= 0 ? parsedFrame : null;

    if (searchParams.has('serverID') && searchParams.has('type')) {
        const serverID = searchParams.get('serverID');
        const type = searchParams.get('type');
        if (serverID && !Number.isNaN(+serverID)) {
            initialFilters.push({
                and: [{ '==': [{ var: 'serverID' }, serverID] }, { '==': [{ var: 'type' }, type] }],
            });
        }
    }

    if (searchParams.size) {
        own.history.replace(own.history.location.pathname);
    }

    return {
        getJob(): void {
            dispatch(
                getJobAsync({
                    referenceID,
                    jobID,
                    initialFrame,
                    initialFilters,
                    initialOpenGuide,
                }),
            );
        },
        saveLogs(): void {
            dispatch(saveLogsAsync());
        },
        closeJob(): void {
            dispatch(closeJobAction());
        },
        changeFrame(frame: number): void {
            dispatch(changeFrameAsync(frame));
        },
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ReferenceAnnotationPageComponent));
